import { render, staticRenderFns } from "./OtherInfo.vue?vue&type=template&id=c134283a&scoped=true&"
import script from "./OtherInfo.vue?vue&type=script&lang=ts&"
export * from "./OtherInfo.vue?vue&type=script&lang=ts&"
import style0 from "./OtherInfo.vue?vue&type=style&index=0&id=c134283a&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c134283a",
  null
  
)

export default component.exports